module.exports = __webpack_public_path__ + "static/img/notDinner.dceec632.webp";